export class UpdatePaymentReq {

     verreqid:Array<String>;
    paymentid :string;
    verreqidarr :String[] ;
    userid:String;

}


